<template>
  <div class="mh-20 mv-12 pb-12">
    <BlTextAv variation="body-16" weight="medium" class="mb-12">Rincian harga</BlTextAv>
    <div>
      <div class="mb-4 flex justify-between">
        <BlTextAv>Harga Kelas</BlTextAv>
        <span class="text-right bl-text">{{ price | money }}</span>
      </div>
      <div class="mb-4 flex justify-between">
        <BlTextAv>Biaya Layanan</BlTextAv>
        <BlTextAv color="success-02" class="text-right font-bold">Gratis</BlTextAv>
      </div>

      <div class="pv-12">
        <div class="border-t border-0 border-dashed border-gray-5"></div>
      </div>

      <BlFlexContainerMv justify-content="space-between" align-items="center" class="mt-4 pt-4">
        <BlTextAv weight="medium">Total pembayaran</BlTextAv>
        <BlTextAv class="qa-txt-price" weight="medium">{{ price | money }}</BlTextAv>
      </BlFlexContainerMv>
    </div>

    <BlBannerMv v-if="getNewPaymentPolicyToggle" variation="warning" class="mt-12 qa-banner-payment-policy-info">
      <BlTextListMv variation="bulleted">
        <BlTextAv variation="caption-12" tag="li">
          <b>1 akun Bukalapak hanya berlaku untuk transaksi 1 nomor Kartu Prakerja.</b>
          Pastikan nomor kartu sudah benar untuk pembayaran.
        </BlTextAv>
        <BlTextAv variation="caption-12" tag="li">
          Jika kamu tidak hadir, slot kelas akan hangus dan tidak ada pengembalian saldo Kartu Prakerja.
        </BlTextAv>
      </BlTextListMv>
    </BlBannerMv>

    <BlButtonAv :disabled="!ctaEnabled" class="mt-16 qa-btn-pay" variation="primary" fullwidth @click="$emit('click')">
      Bayar dengan Kartu Prakerja
    </BlButtonAv>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {BlButtonAv, BlBannerMv, BlTextListMv, BlTextAv} from '@bukalapak/bazaar-mweb-latest';
import {money} from '@bukalapak/toolbox-helper/number-helper';

export default {
  name: 'PrakerjaCheckoutCostInformation',
  filters: {money},
  components: {
    BlButtonAv,
    BlBannerMv,
    BlTextListMv,
    BlTextAv,
  },
  props: {
    price: {
      type: Number,
      default: 0,
    },
    ctaEnabled: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters(['getNewPaymentPolicyToggle']),
  },
};
</script>
